module.exports = __webpack_public_path__ + "media/KikiH.2b7e0934.mp3";